import { render } from "./Acupuncture.vue?vue&type=template&id=60453182"
import script from "./Acupuncture.vue?vue&type=script&lang=js"
export * from "./Acupuncture.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./Acupuncture.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "C:\\Users\\antho\\Documents\\Projects\\ynforma-website\\ynforma-website-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__